import {
  alpha,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  Typography,
} from '@material-ui/core';

import { ReactComponent as PixIcon } from 'assets/images/pix.svg';
import { OrderDetails } from 'store/reducers/templates';
import { centsToBrl } from 'utils/currencyUtils';

import DialogHeader from './DialogHeader';

const useStyles = makeStyles(({ palette, spacing }) => ({
  button: {
    color: 'inherit',
    padding: spacing(1.5, 2),
    marginBlock: spacing(0.5),
    justifyContent: 'flex-start',
  },
  divider: {
    backgroundColor: alpha(palette.text.secondary, 0.2),
  },
  pixCodeContainer: {
    backgroundColor: palette.background.default,
    padding: spacing(1),
    borderRadius: 8,
    display: 'flex',
    gap: spacing(1),
  },
}));

interface ModalPixCopiedProps {
  open: boolean;
  onClose: () => void;
  orderDetails?: OrderDetails;
}

export default function ModalPixCopied({
  open,
  onClose,
  orderDetails,
}: ModalPixCopiedProps) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="order-details-dialog"
    >
      <DialogHeader title="Código Pix copiado" onClose={onClose} />

      <DialogContent
        style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
      >
        <Typography variant="body2">
          Cole o código Pix no app do seu banco para pagar.
        </Typography>

        <Box className={classes.pixCodeContainer}>
          <Box
            style={{
              backgroundColor: 'white',
              padding: 2,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <PixIcon width={32} height={32} />
          </Box>

          <Box
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <Typography variant="body2">
              {orderDetails?.pixDynamicCode?.merchantName}
            </Typography>

            <Typography color="textSecondary" variant="caption">
              {orderDetails?.pixDynamicCode?.code}
            </Typography>
          </Box>
        </Box>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2">Total</Typography>
          <Typography variant="body2">
            {centsToBrl(orderDetails?.priceInCents || 0)}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
